import FETCH from "../utils/fetch";
import ROUTES from "../config/routes";

const saveGoogleToken = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.GOOGLE_SAVE_TOKEN}`,
    body,
  });
  return res;
};

const fetchTasks = async () => {
  let res = await FETCH.googleGet({
    url: ROUTES.GET_DASHBOARD_TASKS,
  });
  return res;
};
const createTask = async (body) => {
  let res = await FETCH.googlePost({
    url: `${ROUTES.CREATE_DASHBOARD_TASK}`,
    body,
  });
  return res;
};
const updateTaskStatus = async (id, body) => {
  let res = await FETCH.googlePut({
    url: ROUTES.UPDATE_DASHBOARD_TASK_STATUS,
    id,
    body,
  });
  return res;
};
const fetchEvents = async (date) => {
  let res = await FETCH.googleGet({
    url: date
      ? `${ROUTES.GET_DASHBOARD_EVENT}?date=${date}`
      : `${ROUTES.GET_DASHBOARD_EVENT}`,
  });
  return res;
};
const createEvent = async (body) => {
  let res = await FETCH.googlePost({
    url: `${ROUTES.CREATE_DASHBOARD_EVENT}`,
    body,
  });
  return res;
};
const updateCalendarEvent = async (calendarId, eventId, body) => {
  let res = await FETCH.googlePost({
    url: `${ROUTES.UPDATE_DASHBOARD_EVENT}`,
    body,
  });
  return res;
};
const deleteCalendarEvent = async (calendarId, eventId) => {
  let res = await FETCH.googleDelete({
    url: `${ROUTES.CREATE_DASHBOARD_EVENT}?calendarId=${calendarId}&eventId=${eventId}`,
  });
  return res;
};
const deleteGoogleTask = async (taskId) => {
  let res = await FETCH.googleDelete({
    url: `${ROUTES.DELETE_GOOGLE_TASK}?taskId=${taskId}`,
  });
  return res;
};
const fetchStoredDocuments = async () => {
  let res = await FETCH.get({
    url: `${ROUTES.CLIENTS_DOCUMENTS}`,
  });
  return res;
};
const fetchStocks = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.GET_STOCKS_LIST}?page=1&limit=100&clientId=${ID}`
        : `${ROUTES.GET_STOCKS_LIST}?page=1&limit=100`,
  });
  return res;
};
const fetchNews = async () => {
  let res = await FETCH.get({
    url: ROUTES.GET_NEWS,
  });
  return res;
};
const fetchMonetaryValueofModule = async (name) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.GET_MONETARY_VALUE}?type=${name}&clientId=${ID}`
        : `${ROUTES.GET_MONETARY_VALUE}?type=${name}`,
  });
  return res;
};
const fetchLiquidAssets = async (page, managedBy = "AP") => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.GET_LIQUID_ASSETS}?page=${page}&limit=10&managedBy=${managedBy}&clientId=${ID}`
        : `${ROUTES.GET_LIQUID_ASSETS}?page=${page}&limit=10&managedBy=${managedBy}`,
    body: {},
  });
  return res;
};
const fetchLiquidAssetsPlaid = async (page) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.GET_LIQUID_ASSETS}?page=${page}&limit=10&managedBy=Plaid&clientId=${ID}`
        : `${ROUTES.GET_LIQUID_ASSETS}?page=${page}&limit=10&managedBy=Plaid`,
    body: {},
  });
  return res;
};
const fetchUserList = async () => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_USERS_LIST}?page=1&limit=1500`,
  });
  return res;
};

const chatInvite = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.CHAT_INVITE}`,
    body,
  });
  return res;
};
const acceptChatInvite = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.ACCEPT_CHAT_INVITE}`,
    body,
  });
  return res;
};
const declineChatInvite = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.DECLINE_CHAT_INVITE}`,
    body,
  });
  return res;
};
const cancelChatInvite = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.CANCEL_CHAT_INVITE}`,
    body,
  });
  return res;
};
const fetchChatHistory = async (id, page) => {
  let res = await FETCH.get({
    url: `${ROUTES.FETCH_CHAT_HISTORY}?conversationId=${id}&page=${page}&limit=20`,
  });
  return res;
};
const chatWithUser = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.CHAT_WITH_USER}`,
    body,
  });
  return res;
};
const fetchChatUserList = async (status) => {
  let res = await FETCH.get({
    url: `${ROUTES.CHAT_USER_INVITED_LISTED}?status=${status}&page=1&limit=20`,
  });
  return res;
};
const sendUserTyping = async (id) => {
  let res = await FETCH.post({
    url: `${ROUTES.USER_TYPING}?conversationId=${id}`,
    body: {},
  });
  return res;
};
const fetchUnReadChatsCount = async (status) => {
  let res = await FETCH.get({
    url: `${ROUTES.UNREAD_CHAT_COUNT}`,
  });
  return res;
};
const addNewAdvisorClient = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.ADD_NEW_ADVISOR_CLIENT}`,
    body,
  });
  return res;
};

const authResetPassword = async (token, body) => {
  let res = await FETCH.ResetPasswordPost({
    url: `${ROUTES.RESET_PASSWORD}`,
    body,
    token,
  });
  return res;
};

const downloadChat = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.CHAT_DOWNLOAD}`,
    body,
  });
  return res;
};
const DASHBOARD_API = {
  saveGoogleToken,
  fetchTasks,
  createTask,
  fetchStoredDocuments,
  fetchStocks,
  createEvent,
  fetchEvents,
  updateTaskStatus,
  fetchNews,
  fetchMonetaryValueofModule,
  deleteCalendarEvent,
  updateCalendarEvent,
  deleteGoogleTask,
  fetchLiquidAssets,
  fetchLiquidAssetsPlaid,
  fetchUserList,
  chatInvite,
  acceptChatInvite,
  declineChatInvite,
  cancelChatInvite,
  fetchChatHistory,
  chatWithUser,
  fetchChatUserList,
  sendUserTyping,
  fetchUnReadChatsCount,
  addNewAdvisorClient,
  authResetPassword,
  downloadChat,
};
export default DASHBOARD_API;
